module.exports = __webpack_public_path__ + "static/img/headerImg.00cc9e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/headerImg.jpg
// module id = Gfmo
// module chunks = 52